import { useEffect as e } from "react";
const t = _ref => {
  let {
    open: o
  } = _ref;
  e(() => (o ? document.body.style.overflow = "hidden" : document.body.style.overflow = "", () => {
    document.body.style.overflow = "";
  }), [o]);
};
export { t as useScrollLock };